export default __webpack_public_path__ + "static/media/2.6091977f.png";